import { getStoreTree, getRecorderBrands } from "../components/cameraPrototypes/shared/captureDeviceService";
import { getInferenceMachine } from "./inferenceMachineService";
import captureDeviceToVideoRecorderShape from "../components/cameraModel/captureDeviceToVideoRecorderShape";

function hostnameFromMachineResponse(data) {
  if (!data) return "";
  return data.machine?.hostname || data.hostname || "";
}

// Fetch the store's CaptureDevice tree and repack each device into the videoRecorder
// shape the capabilities panel consumes. Resolves brand ids -> kind + name and
// inference-machine ids -> hostname, which the tree serializes only as bare ids.
export default async function getStoreCaptureDeviceRecorders(storeId, { localInference = false } = {}) {
  const [devices, brands] = await Promise.all([getStoreTree(storeId), getRecorderBrands()]);
  const deviceList = Array.isArray(devices) ? devices : [];

  const brandKindById = {};
  const brandNameById = {};
  (Array.isArray(brands) ? brands : []).forEach((b) => {
    if (b && b.id != null) {
      brandKindById[b.id] = b.kind ?? null;
      brandNameById[b.id] = b.name ?? null;
    }
  });

  const machineIds = new Set();
  deviceList.forEach((d) => {
    (Array.isArray(d?.cameras) ? d.cameras : []).forEach((c) => {
      if (c?.inference_machine != null) machineIds.add(c.inference_machine);
    });
  });

  const hostnameByMachineId = {};
  await Promise.all(
    Array.from(machineIds).map(async (id) => {
      try {
        const resp = await getInferenceMachine(id);
        hostnameByMachineId[id] = hostnameFromMachineResponse(resp?.data);
      } catch (e) {
        console.error(`Failed to resolve inference machine ${id} hostname:`, e);
        hostnameByMachineId[id] = "";
      }
    })
  );

  return deviceList.map((device) =>
    captureDeviceToVideoRecorderShape(device, { brandKindById, brandNameById, hostnameByMachineId, localInference })
  );
}
